// extracted by mini-css-extract-plugin
export var configurationSection = "_tj-0";